module.exports = __webpack_public_path__ + "img/illustration-undelivered.9d86e0bb.svg";